import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./ViewMajorV1EventManagePage.module.css";
import Header from "shared/Header";
import EventTypeCard from "Events/V1Components/EventTypeCard";
import { useHistory } from "react-router-dom";
import { useViewEvents } from "./useViewEvents";
import Loader from "shared/Loader";

import EventV1InfoForm from "Events/V1Components/EventV1InfoForm";
import PublishingV1InfoForm from "Events/V1Components/PublishingV1InfoForm";
import DateV1Form from "Events/V1Components/DateV1Form";
import NotesV1Form from "Events/V1Components/NotesV1Form";
import TicketingV1Form from "Events/V1Components/TicketingV1Form";
import { useCurrentRoute } from "shared/@hooks/useCurrentRoute";
import VenueV1Form from "Events/V1Components/VenueV1Form";
import Button from "shared/Button";

export function ViewMajorV1EventManagePage() {
  let history = useHistory();
  const { eventId } = useParams();

  const {
    data: viewEventData,
    isError,
    isLoading,
    refetch,
  } = useViewEvents(eventId);
  const [event, setEvent] = useState(null);
  const { data: states } = useCurrentRoute();
  const getStateNameById = (id) => {
    if (id === "0") return "";

    const state = states?.find(
      (state) => state?.stateId?.toString() === id?.toString()
    );

    if (state) {
      return `${state.abbreviation} - ${state.state}`;
    } else {
      return null;
    }
  };
  const [eventInfo, setEventInfo] = useState({
    event: {
      name: "",
      ruleset: "",
      location: "",
      jobCode: "",
      dates: {},
      country: "",
      city: "",
      state: "",
      notes: "",
    },
    marketing: {
      title: "",
      description: "",
      tentative: "",
      visibleCalendar: "",
      bookingStatus: "",
      notes: "",
    },
    analytics: {
      sales: {
        soldOut: "",
        capacity: {
          purchase: 0,
          platinum: 0,
        },
      },
      countingTickets: "",
    },
    venue: {},
    tickets: [],
  });

  useEffect(() => {
    refetch();
  }, [eventId, refetch]);

  useEffect(() => {
    if (viewEventData && !isLoading) {
      const companyInfo = {
        ...viewEventData.venue.company.saved,
        ...Object.fromEntries(
          Object.entries(viewEventData.venue.company.value).filter(
            ([_, v]) => v != null
          )
        ),
      };

      const roomInfo = {
        ...viewEventData.venue.room.saved,
        ...Object.fromEntries(
          Object.entries(viewEventData.venue.room.value).filter(
            ([_, v]) => v != null
          )
        ),
      };
      setEventInfo({
        event: {
          name: viewEventData.event?.name || "",
          ruleset: viewEventData.event?.ruleset || "",
          location: viewEventData.event?.location || "",
          dates: viewEventData?.event?.dates || "",
          country: viewEventData?.event?.country || "",
          city:
            viewEventData?.event?.city?.value ||
            viewEventData?.event?.city?.saved ||
            "",
          state:
            viewEventData?.event?.state || viewEventData?.event?.state || "",
          notes: viewEventData?.event?.notes || "",
        },

        //  marketing
        marketing: {
          title:
            viewEventData?.marketing?.title?.value ||
            viewEventData?.marketing?.title?.saved ||
            "",
          description:
            viewEventData.marketing?.description?.value ||
            viewEventData.marketing?.description?.saved ||
            "",
          tentative:
            viewEventData.marketing?.tentative?.value ||
            viewEventData.marketing?.tentative?.saved ||
            "",
          visibleCalendar:
            viewEventData.marketing?.visibleCalendar?.value ||
            viewEventData.marketing?.visibleCalendar?.saved ||
            "",
          bookingStatus:
            viewEventData.marketing?.bookingStatus?.value ||
            viewEventData.marketing?.bookingStatus?.saved ||
            "",
          notes: viewEventData?.marketing?.notes || "",
        },
        analytics: {
          countingTickets: viewEventData.analytics?.countingTickets || "",
          sales: {
            soldOut: viewEventData.analytics?.sales?.soldOut || "",
            capacity: {
              purchase: viewEventData.analytics?.sales?.capacity?.purchase || 0,
              platinum: viewEventData.analytics?.sales?.capacity?.platinum || 0,
            },
          },
        },
        venue: {
          company: viewEventData?.venue?.company || {},
          room: viewEventData?.venue?.room || {},
        },

        tickets: viewEventData.tickets?.value || [],
      });
    }
  }, [viewEventData, isLoading]);

  //Redirect
  const handleManageInvitees = (sessions) => {
    history.push("/events/manage-invitees");
  };

  const handleEditEvent = () => {
    const ruleset = viewEventData.event?.ruleset.value;

    if (ruleset === "Major v1.0") {
      history.push(`/events/edit/event/majorv1/${eventId}`);
    } else if (ruleset === "Local v1.0") {
      history.push(`/events/edit/event/localv1/${eventId}`);
    } else if (ruleset === "LOS v1.0") {
      history.push(`/events/edit/event/losv1/${eventId}`);
    } else {
      history.push("/");
    }
  };

  if (isLoading && eventInfo) {
    return (
      <div className={styles.loader}>
        <div>
          <Loader />
        </div>
        <div className={styles.loaderText}>Loading View Major V1.0</div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.pageHeader}>
            <Header
              title={eventInfo?.marketing?.title}
              onClick={() => history.goBack()}
            />
          </div>

          <div className={styles.buttonContainer}>
            <Button
              className={styles.editBtn}
              children={"EDIT"}
              onClick={handleEditEvent}
            />
          </div>
        </div>

        <div className={styles.pageContent}>
          {eventInfo && (
            <div className={styles.cardContainer}>
              <EventTypeCard eventInfo={eventInfo.event} />
            </div>
          )}

          <div className={styles.cardContainer}>
            {eventInfo && (
              <EventV1InfoForm marketingInfo={eventInfo} pageMode="view" />
            )}
          </div>
          <div className={styles.cardContainer}>
            {eventInfo && (
              <PublishingV1InfoForm
                publishingInfo={eventInfo}
                pageMode="view"
              />
            )}
          </div>

          <div className={styles.cardContainer}>
            {eventInfo?.event?.dates && (
              <DateV1Form
                dateInfo={eventInfo?.event}
                location={eventInfo?.event?.location?.value}
                ruleset={eventInfo?.event?.ruleset?.value}
                eventName={""}
                pageMode="view"
              />
            )}
          </div>

          {eventInfo?.event?.location?.value === "onsite" && (
            <div className={styles.cardContainer}>
              {eventInfo?.venue && (
                <VenueV1Form venueInfo={eventInfo} pageMode="view" />
              )}
            </div>
          )}

          <div className={styles.cardContainer}>
            {eventInfo && (
              <TicketingV1Form
                ticketGroups={[
                  { name: "Ticket Group Name", tickets: eventInfo?.tickets },
                ]}
                setTicketGroups={() => {}}
                eventName={eventInfo?.event?.name?.value}
              />
            )}
          </div>

          <div className={styles.cardContainer}>
            {eventInfo && <NotesV1Form notesData={eventInfo} pageMode="view" />}
          </div>
        </div>
      </div>
    </>
  );
}
